/* Native theme carousel for five editor-managed creator clips. No autoplay. */
if (!customElements.get('moruga-creator-carousel')) {
  customElements.define('moruga-creator-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.track = this.querySelector('[data-creator-track]');
      if (!this.track) return;
      this.ready = true;
      this.count = Number(this.dataset.count) || 5;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.status = this.querySelector('[data-carousel-status]');
      this.measure = () => {
        const cards = this.track.children;
        if (cards.length <= this.count) return;
        this.step = cards[1].offsetLeft - cards[0].offsetLeft;
        this.period = this.step * this.count;
        this.track.scrollTo({ left: this.period, behavior: 'instant' });
        this.updateAccess();
      };
      this.onScroll = () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => this.normalize(), 140);
      };
      this.onKey = event => {
        if (event.target.closest('video, summary')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      };
      this.querySelector('[data-carousel-prev]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-carousel-next]').addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('play', event => {
        this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
      }, true);
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.track);
      this.measure();
    }
    move(direction) {
      if (!this.step) return;
      this.querySelectorAll('video').forEach(video => video.pause());
      this.track.scrollBy({ left: direction * this.step, behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
    normalize() {
      if (!this.period) return;
      const x = this.track.scrollLeft;
      if (x < this.period - 1) this.track.scrollTo({ left: x + this.period, behavior: 'instant' });
      else if (x >= this.period * 2 - 1) this.track.scrollTo({ left: x - this.period, behavior: 'instant' });
      this.updateAccess();
    }
    updateAccess() {
      const bounds = this.track.getBoundingClientRect();
      const seen = new Set();
      this.track.querySelectorAll('[data-clip]').forEach(card => {
        const r = card.getBoundingClientRect();
        const visible = r.right > bounds.left + 8 && r.left < bounds.right - 8;
        const duplicate = seen.has(card.dataset.clip);
        if (visible) seen.add(card.dataset.clip);
        card.querySelector('summary')?.setAttribute('tabindex', visible && !duplicate ? '0' : '-1');
        card.setAttribute('aria-hidden', visible && !duplicate ? 'false' : 'true');
      });
      if (this.status && this.step) {
        const index = ((Math.round(this.track.scrollLeft / this.step) % this.count) + this.count) % this.count;
        this.status.textContent = `Video ${index + 1} von ${this.count}`;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.settle);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('keydown', this.onKey);
      this.querySelectorAll('video').forEach(video => video.pause());
      this.ready = false;
    }
  });
}
